import axiosInstance from "@/config/axiosInstance";

export const loginUser = async (credentials) => {
  const response = await axiosInstance.post("/api/auth/login", credentials);
  return response.data;
};

export const logoutUser = async () => {
  const response = await axiosInstance.post("/api/auth/logout");
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await axiosInstance.get("/api/auth/me");
  return response.data?.data || null;
};

export const changePassword = async ({ currentPassword, newPassword }) => {
  const response = await axiosInstance.patch("/api/auth/change-password", {
    currentPassword,
    newPassword,
  });
  return response.data;
};
